import { Pipe, PipeTransform } from '@angular/core'
import dayjs from 'dayjs'
import { TranslateService } from '@ngx-translate/core'

import { dateFormats } from '@app/core/constants/dateFormats'
import { AuthService } from '@app/modules/auth/auth.service'

@Pipe({
  name: 'historyDayOfWeek',
  standalone: false,
})
export class HistoryDayOfWeek implements PipeTransform {
  constructor(
    private readonly authService: AuthService,
    private readonly translateService: TranslateService,
  ) {}

  transform(date?: string): string {
    const dateFormat = this.authService.getCurrentUserDateFormat() || dateFormats.date
    const dayjsDate = dayjs(date).tz()

    const dayjsDateCurrent = dayjs().tz()

    const diff = dayjsDateCurrent.diff(dayjsDate, 'day')

    const diffNumber = Number(diff.toFixed(0))

    if (diffNumber === 0) {
      return <string>this.translateService.instant('DATE_RANGES.TODAY')
    }

    if (diffNumber === 1) {
      return <string>this.translateService.instant('DATE_RANGES.YESTERDAY')
    }

    if (diffNumber > 1 && diffNumber < 7) {
      return this.weekdayToString(dayjsDate.weekday())
    }

    return dayjsDate.format(dateFormat)
  }

  private weekdayToString(weekday: number): string {
    switch (weekday) {
      case 0:
        return <string>this.translateService.instant('DATE_RANGES.MONDAY')
      case 1:
        return <string>this.translateService.instant('DATE_RANGES.TUESDAY')
      case 2:
        return <string>this.translateService.instant('DATE_RANGES.WEDNESDAY')
      case 3:
        return <string>this.translateService.instant('DATE_RANGES.THURSDAY')
      case 4:
        return <string>this.translateService.instant('DATE_RANGES.FRIDAY')
      case 5:
        return <string>this.translateService.instant('DATE_RANGES.SATURDAY')
      case 6:
        return <string>this.translateService.instant('DATE_RANGES.SUNDAY')
      default:
        return ''
    }
  }
}
